import { render, staticRenderFns } from "./default-admin.vue?vue&type=template&id=9a7b43f4"
import script from "./default-admin.vue?vue&type=script&lang=js"
export * from "./default-admin.vue?vue&type=script&lang=js"
import style0 from "./default-admin.vue?vue&type=style&index=0&id=9a7b43f4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports